export enum EPaymentProviderResponse {
    STANCER = "STANCER",
    ELAVON = "ELAVON",
}

export interface IPaymentProviderResponse {
    paymentProvider: EPaymentProviderResponse;
}

export type TIsNewPaymentProvider = boolean;
